export class Document {

    public id: string = "0";
    public filename: string;
    
    public approved: boolean;
    public proofOfVaccine  : boolean = false;
    
    public date: Date;

    public member_name: string;
    public member_id: string;
    
    public folder_id: string;
    public folder_name: string = '';

    public url: string;
    
    constructor() {}
}